import FilterSection from "./component"
import styled from "styled-components"

export default styled(FilterSection)`
    display: flex;
    justify-content: space-between;
`